import { ReduxStore } from 'store/types';

function createIsLoading(state: ReduxStore): boolean {
  return state.product.create.config.isLoading;
}

export default createIsLoading;
